export const getLanguages = (): Language[] => {
  return [
    {
      label: "Arabic",
      value: "ar",
      direction: "rtl",
      datepicker: "ar",
      locale: "ar",
      emoji: "🇸🇦",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Czech",
      value: "cs",
      direction: "ltr",
      datepicker: "cs",
      locale: "cs",
      emoji: "🇨🇿",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Danish",
      value: "da",
      direction: "ltr",
      datepicker: "da",
      locale: "da",
      emoji: "🇩🇰",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "German",
      value: "de",
      direction: "ltr",
      datepicker: "de",
      locale: "de",
      emoji: "🇩🇪",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "English US",
      value: "en",
      direction: "ltr",
      datepicker: "default",
      locale: "en",
      emoji: "🇺🇸",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "English GB",
      value: "en-gb",
      direction: "ltr",
      datepicker: "default",
      locale: "en",
      emoji: "🇬🇧",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Estonian",
      value: "et",
      direction: "ltr",
      datepicker: "et",
      locale: "et",
      emoji: "🇪🇪",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Finnish",
      value: "fi",
      direction: "ltr",
      datepicker: "fi",
      locale: "fi",
      emoji: "🇫🇮",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Spanish",
      value: "es",
      direction: "ltr",
      datepicker: "es",
      locale: "es",
      emoji: "🇪🇸",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "French",
      value: "fr",
      direction: "ltr",
      datepicker: "fr",
      locale: "fr",
      emoji: "🇫🇷",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Greek",
      value: "el",
      direction: "ltr",
      datepicker: "gr",
      locale: "el",
      emoji: "🇬🇷",
      tags: ["source", "target"],
    },
    {
      label: "Hebrew",
      value: "he",
      direction: "rtl",
      datepicker: "he",
      locale: "he",
      emoji: "🇮🇱",
      tags: [],
    },
    {
      label: "Hungarian",
      value: "hu",
      direction: "ltr",
      datepicker: "hu",
      locale: "hu",
      emoji: "🇭🇺",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Italian",
      value: "it",
      direction: "ltr",
      datepicker: "it",
      locale: "it",
      emoji: "🇮🇹",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Japanese",
      value: "ja",
      direction: "ltr",
      datepicker: "ja",
      locale: "ja",
      emoji: "🇯🇵",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Korean",
      value: "ko",
      direction: "ltr",
      datepicker: "ko",
      locale: "ko",
      emoji: "🇰🇷",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Norwegian",
      value: "nb",
      direction: "ltr",
      datepicker: "no",
      locale: "nb",
      emoji: "🇳🇴",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Dutch",
      value: "nl",
      direction: "ltr",
      datepicker: "nl",
      locale: "nl",
      emoji: "🇳🇱",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Polish",
      value: "pl",
      direction: "ltr",
      datepicker: "pl",
      locale: "pl",
      emoji: "🇵🇱",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Portuguese",
      value: "pt",
      direction: "ltr",
      datepicker: "pt",
      locale: "pt",
      emoji: "🇵🇹",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Portuguese (Brazilian)",
      value: "pt-br",
      direction: "ltr",
      datepicker: "pt",
      locale: "pt",
      emoji: "🇧🇷",
      tags: ["target", "auto-translate"],
    },
    {
      label: "Portuguese (Other)",
      value: "pt-pt",
      direction: "ltr",
      datepicker: "pt",
      locale: "pt",
      emoji: "🇵🇹",
      tags: ["target", "auto-translate"],
    },
    {
      label: "Romanian",
      value: "ro",
      direction: "ltr",
      datepicker: "ro",
      locale: "ro",
      emoji: "🇷🇴",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Russian",
      value: "ru",
      direction: "ltr",
      datepicker: "ru",
      locale: "ru",
      emoji: "🇷🇺",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Slovak",
      value: "sk",
      direction: "ltr",
      datepicker: "sk",
      locale: "sk",
      emoji: "🇸🇰",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Slovenian",
      value: "sl",
      direction: "ltr",
      datepicker: "sl",
      locale: "sl",
      emoji: "🇸🇮",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Swedish",
      value: "sv",
      direction: "ltr",
      datepicker: "sv",
      locale: "sv",
      emoji: "🇸🇪",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Turkish",
      value: "tr",
      direction: "ltr",
      datepicker: "tr",
      locale: "tr",
      emoji: "🇹🇷",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Ukrainian",
      value: "uk",
      direction: "ltr",
      datepicker: "uk",
      locale: "uk",
      emoji: "🇺🇦",
      tags: ["source", "target", "auto-translate"],
    },
    {
      label: "Vietnamese",
      value: "vi",
      direction: "ltr",
      datepicker: "vi",
      locale: "vi",
      emoji: "🇻🇳",
      tags: ["target"],
    },
    {
      label: "Chinese (Any)",
      value: "zh",
      direction: "ltr",
      datepicker: "zh",
      locale: "zh",
      emoji: "🇨🇳",
      tags: ["source", "target", "auto-translate"],
    },
  ];
};

export function findLanguageItem(value: string | null): Language {
  const found = getLanguages().find((l) =>
    l.value === (value ?? "").toLowerCase()
  );
  if (found) {
    return found;
  } else {
    return getLanguages().find((l) => l.value === "en") as Language;
  }
}

export function existsLanguageItem(value: string | null): boolean {
  if (!value) {
    return false;
  }
  return getLanguages().some((l) => l.value === value.toLowerCase());
}
